export class Item {
    itemid: number;
    itemname: string;
    itemcategoryid: number;  
    itemuomid: number;    
    gst: number;
    brandid: number;
    active: number;
}